import { render } from "./updatesecurity.vue?vue&type=template&id=dc25d2ac"
import script from "./updatesecurity.vue?vue&type=script&lang=js"
export * from "./updatesecurity.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__